export const notesContent = `AI Framework is a collection of AI tools and resources organized as a tree — inspired by OSINT Framework.

Use the tree on the left. Click a node to expand its children. Leaf nodes are actual links that open in a new tab.

Legend:
  (T)  Free / open source tool
  (R)  Requires registration
  (M)  Paid or freemium (paywall)
  (D)  Dangerous / underground — use at your own risk

Ethical use only.
Many 'underground' AI tools listed here (deepfake, face-swap, jailbreak LLMs, uncensored roleplay) can be used to hurt real people. Some uses — like non-consensual intimate imagery, fraud, or targeting minors — are illegal in most jurisdictions. This framework catalogs what exists so you can defend against, research, or ethically understand it. Don't be a jerk.

Suggest an addition? PRs welcome (mock).
`;
